class DotMeterian{
    constructor(exclusions, full=false){
        
        this.dotMeterian= {
            exclusions:{
                security:{
                    cves:[],
                    advices:[],
                    libraries:[]
                },
                stability:{
                    libraries:[]
                },
                licensing:{
                    libraries:[]
                }
            }
        }
        if(!exclusions) return;

        const security = (securityExclusions)=>{
            const library = (exclusion)=>{
                this.dotMeterian.exclusions.security.libraries.push({
                    library: exclusion.library,
                    version: exclusion.version,
                    description: exclusion.description,
                    reason: exclusion.reason,
                    transitive: exclusion.transitive || false
                })
            }
            const cve = (exclusion)=>{
                this.dotMeterian.exclusions.security.cves.push({
                    cve: exclusion.cve,
                    version: exclusion.version,
                    description: exclusion.description,
                    reason: exclusion.reason,
                    transitive: exclusion.transitive || false
                })
            }
            const advice = (exclusion)=>{
                this.dotMeterian.exclusions.security.advices.push({
                    uuid: exclusion.uuid,
                    reason: exclusion.reason,
                    description: exclusion.description,
                    transitive: exclusion.transitive || false
                })
            }

            for(const exclusion of securityExclusions.libraries ){
                if (!full && exclusion.readonly) continue
                library(exclusion);
            }
            for(const exclusion of securityExclusions.cves){
                if (!full && exclusion.readonly) continue
                cve(exclusion)
            }
            for(const exclusion of securityExclusions.advices){
                if (!full && exclusion.readonly) continue
                advice(exclusion)
            }

        }

        const stability = (stabilityExclusions)=>{
            const library = (exclusion)=>{
                this.dotMeterian.exclusions.stability.libraries.push({
                    library: exclusion.library,
                    version: exclusion.version,
                    description: exclusion.description,
                    reason: exclusion.reason
                })
            }
            for(const exclusion of stabilityExclusions.libraries ){
                if (!full && exclusion.readonly) continue
                library(exclusion);
            }
        }

        const licensing = (licensingExclusions)=>{
            const library = (exclusion)=>{
                this.dotMeterian.exclusions.licensing.libraries.push({
                    library: exclusion.library,
                    version: exclusion.version,
                    description: exclusion.description,
                    reason: exclusion.reason
                })
            }
            for(const exclusion of licensingExclusions.libraries ){
                if (!full && exclusion.readonly) continue
                library(exclusion);
            }
        }


        security(exclusions.security);
        stability(exclusions.stability);
        licensing(exclusions.licensing);

    }
}

export default (exclusions, full)=>new DotMeterian(exclusions, full).dotMeterian;